<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Refund / Elective Fee Payment</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center">
                <v-col cols="12" sm="3" md="3">
                    <v-combobox v-model="ay" rounded :items="ay_list" label="Select Academic Year"
                        item-text="academicyear" outlined dense @click="show = false"></v-combobox>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-autocomplete v-model="status" rounded return-object @change="getStud()" :items="status_list"
                        label="Select Status" item-text="name" outlined dense
                        prepend-icon="mdi-account-child-circle"></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-combobox v-model="registration_no" rounded :items="stud_list" label="Select Student"
                        item-text="name" outlined dense prepend-icon="mdi-account-child-circle" @click="show = false"
                        @change="getFeesDetails()"></v-combobox>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-autocomplete v-model="payment_type" rounded :items="payment_type_list"
                        label="Select Payment Type" item-text="name" return-object outlined dense
                        prepend-icon="mdi-account-child-circle" @change="getFeesDetails()"></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="3" md="3" v-if="payment_type && mics_other_fees_student_records != ''">
                    <v-autocomplete v-model="misc_fees" rounded :items="mics_other_fees_student_records"
                        label="Select Misc Fee" item-text="exam_name" item-value="id" outlined dense
                        prepend-icon="mdi-account-child-circle"></v-autocomplete>
                </v-col>
                <v-btn class="button mt-3" v-if="registration_no != null && ay != null"
                    @click="getStudRefundDetails()">Proceed</v-btn>
            </v-row>
            <v-col cols="12" sm="12" md="12" v-if="refund_payment_list.length > 0">
                <v-toolbar dense class="toolbar" flat color="white">
                    <v-toolbar-title>
                        {{ is_elective_refund ? 'Elective Fee Payment History' : 'Refunded Fee History' }}
                    </v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-data-table :items="refund_payment_list" :headers="headers" class="elevation-1 mytable" dense>
                    <template v-slot:[`item.receipt_no`]="{ item }">
                        <v-tooltip top color="warning">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn class="mt-1 mb-1" outlined rounded small color="warning" v-bind="attrs" v-on="on"
                                    @click="print(item)">
                                    <v-icon color="warning">mdi-printer</v-icon>{{ item.receipt_no }}</v-btn>
                            </template>
                            <span> Print Fee Receipt!!! </span>
                        </v-tooltip>
                    </template>
                </v-data-table>
                <!-- {{refund_payment_list}} -->
            </v-col>
            <v-col cols="12" sm="12" md="12" v-if="is_elective_refund || fee_student_master_details.length > 0">
                <v-toolbar dense class="toolbar" flat color="white">
                    <v-toolbar-title>Student Details</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row>
                    <v-col cols="12" sm="3" md="3">
                        <strong>Student:-</strong>
                        <span v-if="is_elective_refund">
                            {{ registration_no.registration_number }}
                        </span>
                        <span v-else>
                            {{ fee_student_master_details[0].learner }}
                        </span>
                    </v-col>

                    <v-col cols="12" sm="3" md="3"><strong>Academic Year:-</strong>{{ ay.academicyear }}</v-col>

                    <v-col cols="12" sm="3" md="3" v-if="!is_elective_refund">
                        <strong>Standard:-</strong>
                        {{ fee_student_master_details[0].standard }}
                    </v-col>

                    <v-col cols="12" sm="3" md="3" v-if="!is_elective_refund">
                        <strong>Quota:-</strong>
                        {{ fee_student_master_details[0].quota }}
                    </v-col>

                    <v-col cols="12" sm="3" md="3" v-if="!is_elective_refund">
                        <strong>Excess Amount:-</strong>
                        {{ fee_student_master_details[0].excess_amount }}
                    </v-col>

                    <v-col cols="12" sm="3" md="3" v-if="!is_elective_refund">
                        <strong>Refunded Amount:-</strong>

                        <span v-if="is_elective_refund">
                            {{ total_refunded_amount }}
                        </span>

                        <span v-else>
                            {{ fee_student_master_details[0].refunded_amount }}
                        </span>
                    </v-col>

                    <v-col cols="12" sm="3" md="3" v-if="!is_elective_refund">
                        <strong>Paid Amount:-</strong>

                        <span v-if="is_elective_refund">
                            {{ total_comp_paid_amount }}
                        </span>

                        <span v-else>
                            {{ total_comp_paid_amount }}
                        </span>
                    </v-col>

                    </v-row>
                    <v-row>
                    <v-col cols="12" sm="3" md="3">
                        <v-text-field dense rounded outlined type="number" v-model="refund_amt"
                            placeholder="Enter Amount which you want to refund"
                            label="Enter Amount which you want to refund">
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" sm="3" md="3">
                        <v-combobox dense rounded required autocomplete="off" :items="mode_list" item-text="name"
                            v-model="mode" label="Payment Mode" name="mode" outlined>
                        </v-combobox>
                    </v-col>

                    <v-col cols="12" sm="3" md="3">
                        <v-text-field dense rounded outlined v-model="trans_id" placeholder="Enter Transaction ID"
                            label="Enter Transaction ID">
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" sm="3" md="3">
                        <v-combobox dense rounded required autocomplete="off" :items="bank_list" v-model="bank"
                            label="Bank" name="bank" item-text="name" item-value="id" outlined>
                        </v-combobox>
                    </v-col>

                    <v-col cols="12" sm="3">
                        <v-text-field rounded label="Enter Remark" placeholder="Enter Remark" v-model="receipt_remark"
                            dense outlined>
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" sm="3" md="3">
                        <v-menu v-model="menu11" :close-on-content-click="false" :nudge-right="40"
                            transition="scale-transition" offset-y min-width="auto">

                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field dense rounded outlined v-model="receipt_date" label="Receipt Date"
                                    name="receipt_date" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on">
                                </v-text-field>
                            </template>

                            <v-date-picker v-model="receipt_date" name="receipt_date" @input="menu11 = false">
                            </v-date-picker>

                        </v-menu>
                    </v-col>

                    <v-col cols="12" sm="3" md="3">
                        <v-menu v-model="menu12" :close-on-content-click="false" :nudge-right="40"
                            transition="scale-transition" offset-y min-width="auto">

                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field dense outlined rounded v-model="trans_date" label="Transaction Date"
                                    name="trans_date" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on">
                                </v-text-field>
                            </template>

                            <v-date-picker v-model="trans_date" name="trans_date" @input="menu12 = false">
                            </v-date-picker>

                        </v-menu>
                    </v-col>

                    <v-col cols="12" sm="3" md="3">
                        <v-btn class="button pt-0 mt-0" v-if="refund_amt != null && mode != null"
                            @click="saveStudRefundDetails()">
                            Proceed
                        </v-btn>
                    </v-col>

                </v-row>
            </v-col>
        </v-card>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import axios from "axios";
export default {
    data: () => ({
        show: false,
        refund_amt: null,
        registration_no: "",
        stud_list: [],
        snackbar_msg: "",
        color: "",
        snackbar: false,
        overlay: false,
        current_ay: "",
        search: "",
        s3url: "",
        ay_list: [],
        ay: null,
        fee_student_master_details: [],
        refund_payment_list: [],
        trans_id: null,
        bank_list: null,
        bank: null,
        mode: null,
        mode_list: null,
        receipt_remark: null,
        receipt_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
        trans_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
        menu: false,
        modal: false,
        menu2: false,
        menu11: false,
        menu12: false,
        menu15: false,
        org_basic_data: [],
        status_list: null,
        status: null,
        payment_type_list: null,
        payment_type: null,
        total_comp_paid_amount: null,
        is_elective_refund: false,
        total_refunded_amount: 0,
        mics_other_fees_student_records: [],
        misc_fees: null,
        headers: [
            { text: "Receipt No", value: "receipt_no", sortable: true },
            { text: "Amount", value: "amount", sortable: true },
            { text: "Date", value: "receipt_date", sortable: true },
            { text: "Transaction Date", value: "trans_date", sortable: true },
            { text: "Transaction ID", value: "trans_id", sortable: true },
            { text: "Payment Mode", value: "paymentmode", sortable: true },
            { text: "Bank", value: "bank", sortable: true },
            { text: "Remark", value: "remark", sortable: true },
        ],
    }),
    methods: {
        print(item) {
            this.$session.set("receipt_data", JSON.stringify(item));
            this.$session.set("is_elective_refund", this.is_elective_refund);
            this.$session.set("org_basic_data", JSON.stringify(this.org_basic_data));
            let routeData = this.$router.resolve({ name: "refund-receipt-print" });
            window.open(routeData.href, "_blank");
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        getStud() {
            //  console.log(this.status)
            // console.log(this.status.stud_list)
            this.registration_no = null;
            this.stud_list = this.status.stud_list;
        },
        async getFeesDetails() {
            if (this.payment_type.name == "MISC") {
                if (this.registration_no && this.payment_type) {
                    const data = {
                        child: this.registration_no.registration_number,
                        ay: this.ay.ay_id,
                    };
                    try {
                        const res = await axios.post("/AccountingAndFees/getMiscPaymentInfoOffline", data);
                        if (res.data.flag == "YES") {
                            this.mics_other_fees_student_records = res.data.mics_other_fees_student_records;
                            if (this.mics_other_fees_student_records.length == 0) {
                                this.showSnackbar("#b71c1c", "0 Misc Fees Receipt Fount...");
                            }
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    } catch (error) {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    } finally {
                    }
                }
                else {
                    this.showSnackbar("#b71c1c", "Please select all fields..");
                    return;
                }
            }
        },
        async saveStudRefundDetails() {

            if (!this.refund_amt || this.refund_amt <= 0) {
                this.showSnackbar("#b71c1c", "Please enter refund amount.");
                return;
            }

            if (!this.mode) {
                this.showSnackbar("#b71c1c", "Please select payment mode.");
                return;
            }

            if (!this.is_elective_refund) {
                if (this.fee_student_master_details.length > 0) {
                    if (this.fee_student_master_details[0].excess_amount != 0) {
                        if (Number(this.fee_student_master_details[0].excess_amount) <
                            Number(this.refund_amt)) {
                            this.showSnackbar(
                                "#b71c1c",
                                "Amount should be less than excess amount!!!"
                            );
                            return;
                        }
                    }
                }

                if (this.total_comp_paid_amount != 0) {
                    if (Number(this.total_comp_paid_amount) <
                        Number(this.refund_amt)) {
                        this.showSnackbar(
                            "#b71c1c",
                            "Amount should be less than installment paid amount!!!"
                        );
                        return;
                    }
                }
            }

            const data = {
                registration_no: this.registration_no.registration_number,
                ay: this.ay.ay_id,
                refund_amt: this.refund_amt,
                mode: this.mode,
                receipt_remark: this.receipt_remark,
                receipt_date: this.receipt_date,
                trans_id: this.trans_id,
                trans_date: this.trans_date,
                bank: this.bank,
                payment_type: this.payment_type.id,
                misc_fees: this.misc_fees
            };

            console.log("Refund data::::", data);

            try {

                const res = await axios.post(
                    "/AccountingAndFees/saveStudRefundDetails",
                    data
                );

                if (res.data.flag == "YES") {

                    this.showSnackbar(
                        "#4CAF50",
                        "Amount Refunded Successfully.."
                    );

                    await this.getStudRefundDetails();

                    this.refund_amt = null;
                    this.mode = null;
                    this.bank = null;
                    this.trans_id = null;
                    this.receipt_remark = null;

                } else {
                    this.showSnackbar("#b71c1c",res.data.fmsg || "Something went wrong!!!");
                    sessionStorage.setItem("error-trace",res.data.error_trace);
                }

            } catch (error) {
                this.showSnackbar("#b71c1c", "Something went wrong...");
            }
        },
        async getStudRefundDetails() {

            const data = {
                registration_no: this.registration_no.registration_number,
                ay: this.ay.ay_id,
                payment_type: this.payment_type.id,
                misc_fees: this.misc_fees
            };

            try {

                const res = await axios.post(
                    "/AccountingAndFees/getStudRefundDetails",
                    data
                );

                if (res.data.flag == "YES") {

                    this.fee_student_master_details = res.data.fee_student_master_details || [];
                    this.refund_payment_list = res.data.refund_payment_list || [];
                    this.org_basic_data = res.data.org_basic_data || [];
                    this.mode_list = res.data.mode_list || [];
                    this.bank_list = res.data.bank_list || [];
                    this.total_comp_paid_amount = Number(res.data.total_comp_paid_amount || 0);
                    this.total_refunded_amount = Number(res.data.total_refunded_amount || 0);
                    this.is_elective_refund = res.data.is_elective_refund === true;

                } else if (res.data.flag == "NO") {
                    this.showSnackbar( "#b71c1c",res.data.fmsg);

                } else {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }

            } catch (error) {
                this.showSnackbar("#b71c1c", "Something went wrong..." );
            }
        },
    },

    mounted() {
        axios
            .post("/FeesStructureInstallment/getdata")
            .then((res) => {
                if (res.data.msg == "200") {
                    // this.stud_list = res.data.stud_list;
                    this.payment_type_list = res.data.payment_type_list;
                    this.status_list = res.data.all_stud_list;
                    this.ay_list = res.data.aylist;
                } else {
                    alert("Somthing went wrong!!!");
                }
            })
            .catch((error) => {
                alert("Somthing went wrong!!!");
            })
            .finally(() => {
                this.comp_load = false;
            });
    },
};
</script>
<style scoped>
.text {
    color: red !important;
}

.radiospace {
    margin: 1rem !important;
    padding: 0%;
}

.btn-css {
    outline: 0 !important;
    outline-offset: 0 !important;
    background-image: none !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    background-color: #fff !important;
    text-decoration: underline;
    color: #0f2027 !important;
    text-align: left;
}

.btn-css:hover {
    outline: 0 !important;
    outline-offset: 0 !important;
    background-image: none !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    background-color: #ffff !important;
    color: #0f2027 !important;
    text-decoration: underline;
    text-align: left;
}

.t-row {
    padding: 1rem i !important;
}

.mytable2 /deep/ thead th {
    background: #0f2027 !important;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right,
            #2c5364,
            #203a43,
            #0f2027) !important;
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right,
            #2c5364,
            #203a43,
            #0f2027) !important;
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
}

.delete-avatar {
    transition: 0.3s;
    border: 1px solid red;
    margin: 0.2rem !important;
}

.delete-avatar:hover {
    background-color: transparent;
}

.delete-v-icon {
    padding-left: 8px;
    padding-top: 1px;
    font-size: 15px;
}

.delete-v-icon:hover {
    color: white;
}

.v-dialogss {
    bottom: 880;
    right: 0;
}
</style>
